import Swiper from 'swiper/swiper-bundle';

if (jQuery('.carousel').length) {
  var swiper = new Swiper('.carousel__swiper', {
    loop: true,
    // speed: 1000,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });
}